import React from 'react'
import '../styles/PromisesProducts.css';

export default function PromisesProduct() {
    return (
        <div>
            <div className="promise-container">
                <div className="container-slider-text-promise">
                    <div className="slider-container-promise">
                        <div className="slider-text-promise">
                            日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る
                        </div>
                    </div>
                    <div className="row-blackbox-promise">
                        <div className="item1-blackbox-promise">
                        <img width="80" height="80" src="https://img.icons8.com/ios-filled/50/FFFFFF/successful-delivery.png" alt="successful-delivery"/>
                            <h5>Free delivery</h5>
                            <p>Your order will be shipped and processed within 1 to 2 business days. We ship worldwide.</p>
                        </div>
                        <div className="item2-blackbox-promise">
                        <img width="80" height="80" src="https://img.icons8.com/pastel-glyph/64/FFFFFF/card-in-use--v1.png" alt="card-in-use--v1"/>
                            <h5>Secured payment</h5>
                            <p>Our U.S. SSL technology ensures encryption and a secure transaction in all countries of the worlds.</p>
                        </div>
                        <div className="item3-blackbox-promise">
                        <img width="80" height="80" src="https://img.icons8.com/sf-black-filled/64/FFFFFF/return.png" alt="return"/>
                            <h5>Free returns</h5>
                            <p>We offer a return policy on all orders over $150 within 14 days of your purchase.</p>
                        </div>
                    </div>
                    <div className="slider-container2-promise">
                        <div className="slider-text2-promise">
                            日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る 日 本 の ナ ン バ ー ワ ン シ ョ ッ プ の 歴 史 に 迫 る
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
